import moment from 'moment'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {IInputMutation} from '../store/dipatches'
import {ListGroup} from 'react-bootstrap'
import {includeConector} from '../helpers'

interface IModalDispatchPendigProps {
  isOpen: boolean
  onClose: () => void
  info: IInputMutation
}

export const ModalInfoDispatchPendig = ({info, isOpen, onClose}: IModalDispatchPendigProps) => {
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Despacho</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup>
          <ListGroup.Item as='li' className='d-flex justify-content-between align-items-start'>
            <div className='fw-bold'>Cliente</div>
            <div>{info.client.split('***')[1]}</div>
          </ListGroup.Item>
          <ListGroup.Item as='li' className='d-flex justify-content-between align-items-start'>
            <div className='fw-bold'>Hora de salida</div>
            <div>{moment(info.departureTime).format('DD MMM [del] YY - hh:mm A')}</div>
          </ListGroup.Item>
          <ListGroup.Item as='li' className='d-flex justify-content-between align-items-start'>
            <div className='fw-bold'>Productos ({info.products.length})</div>
            <div>
              {info.products.map((pro) => (
                <div key={pro.product} style={{textAlign: 'end'}}>
                  {pro.quantityDispatch} {includeConector(pro.product.split('***')[1])}
                </div>
              ))}
            </div>
          </ListGroup.Item>
          <ListGroup.Item as='li' className='d-flex justify-content-between align-items-start'>
            <div className='fw-bold'>Placa</div>
            <div className='text-uppercase'>{info.plate}</div>
          </ListGroup.Item>
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={onClose}>
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
